import { useState } from "react";
import { Box, Typography } from "@mui/material";
import usePayments from "../../hooks/usePayments";
import DialogEndPayment from "./DialogEndPayment";
import Cards from "./Cards";
import { useUserState } from "../../state/user";
import CmdBalance from "../CmdBalance/CmdBalance";
import { useTranslation } from "react-i18next";
import { typography } from "../../utils/typography";
import { semanticColors } from "../../utils/colors";

export default function Plans() {
  const { t } = useTranslation();
  const [selectedPlan, setSelectedPlan] = useState("");
  const { user } = useUserState();

  const { onClickPayment, loading: loadingPayments } = usePayments();

  const onClickCard = (id: string) => {
    const emails: any = Object.values((user as any).personalInfo.emails);
    onClickPayment({ email: emails[0].value, plan: id });
    setSelectedPlan(id);
  };

  return (
    <>
      <DialogEndPayment />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: "24px",
          py: "48px",
          gap: "48px",
          width: "100%"
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            alignSelf: "stretch"
          }}
        >
          <Typography
            sx={{
              ...typography.heading.xl,
              color: semanticColors.text.primary,
              textAlign: "center"
            }}
          >
            {t("cmds.plansTitle")}
          </Typography>

          {/* The current balance is the context for deciding what to buy. */}
          <CmdBalance variant="chip" />
        </Box>
        <Cards
          onClickCard={onClickCard}
          loadingPayments={loadingPayments || !user}
          selectedPlan={selectedPlan}
        />
      </Box>
    </>
  );
}
